import type { NoteChannel } from "../types";

// The channels a fresh database starts with. The real ones are seeded by
// 20261001140000_note_channels.sql and coloured by 20261001150000; this copy is
// what the demo provider and the tests start from, so keep them in step.
// LCCRM-87.
export const DEFAULT_NOTE_CHANNELS: NoteChannel[] = [
  { id: 1, name: "Email", key: "email", color: "#ef4444" },
  { id: 2, name: "LinkedIn", key: null, color: "#2563eb" },
  { id: 3, name: "Text", key: null, color: "#22c55e" },
  { id: 4, name: "Call", key: null, color: "#f59e0b" },
  { id: 5, name: "Meeting", key: null, color: "#93c5fd" },
];

/** A channel name as it is compared: the database's unique index does the same. */
const comparable = (name: string) => name.trim().toLowerCase();

/** The channel that already has this name, however it is capitalised. */
export const findChannelByName = <T extends Pick<NoteChannel, "name">>(
  channels: T[] | undefined,
  name: string,
): T | undefined => {
  const wanted = comparable(name);
  if (!wanted) return undefined;
  return channels?.find((channel) => comparable(channel.name) === wanted);
};

/** A channel the system assigns itself (Email) cannot be deleted. */
export const isBuiltInChannel = (channel: Pick<NoteChannel, "key">) =>
  channel.key != null && channel.key !== "";
